import Formatter from '../class/Formatter';
import i18n from '../i18n';

const mixinDinamicCharts = {
  methods: {
    spline(title_, subtitle_, categories_, series_, showValue_ = false) {
      let chartOptions = {
        chart: {
          zoomType: 'xy',
          type: 'spline',
        },
        title: {
          text: title_ ? title_ : i18n.t('uti.mixin_dinamic_charts.graphic_title'),
          x: -20,
        },
        subtitle: {
          text: subtitle_ ? subtitle_ : i18n.t('uti.mixin_dinamic_charts.graphic_subtitle'),
          x: -20,
        },
        xAxis: {
          categories: categories_,
          labels: {
            rotation: -90,
          },
        },
        yAxis: [],
        tooltip: {
          formatter: function () {
            const value = Formatter.formatMoney(this.y, 2);
            const suffix = this.series.tooltipOptions.valueSuffix;
            const tooltip = `<span style="font-size: 10px">${this.key}</span>
                    <br/>
                    <span style="color:${this.series.color}">\u25CF</span>
                    ${this.series.name}: <strong>${value}${suffix ? suffix : ''
              }</strong><br/>`;

            return tooltip;
          },
          useHTML: true,
        },
        plotOptions: {
          spline: {
            //stacking: 'percent',//'normal',
            dataLabels: {
              enabled: showValue_,
              //format: '{point.y:.1f}',
              color: 'black',
              /* style: {
                    textShadow: '0 0 3px black, 0 0 3px black'
                }*/
            },
          },
        },
        series: series_,
      };

      for (let i = 0; i < series_.length; i = i + 1) {
        chartOptions.yAxis.push({
          labels: {
            format: `{value}${series_[i].tooltip.valueSuffix}`,
            style: {
              color: series_[i].color,
            },
          },
          title: {
            text: series_[i].name,
            style: {
              color: series_[i].color,
            },
          },
          tickAmount: 5,
          opposite: i % 2 == 0 ? false : true,
        });
      }

      return chartOptions;
    },
    barChart(
      title_,
      subtitle_,
      categories_,
      series_,
      tipo,
      minHeight,
      showValue_ = false
    ) {
      let chartOptions = {
        chart: {
          type: 'bar',
          scrollablePlotArea: {
            minHeight: minHeight,
            scrollPositionX: 1,
          },
        },
        title: {
          text: title_ ? title_ : i18n.t('uti.mixin_dinamic_charts.graphic_title'),
          x: -20,
        },
        subtitle: {
          text: subtitle_ ? i18n.t('uti.mixin_dinamic_charts.by') + subtitle_ : i18n.t('uti.mixin_dinamic_charts.graphic_subtitle'),
          x: -20,
        },
        xAxis: {
          categories: categories_,
          title: {
            text: subtitle_.charAt(0).toUpperCase() + subtitle_.slice(1),
          },
        },
        yAxis: {
          min: 0,
          title: {
            text:
              tipo == 'volumen'
                ? i18n.t('uti.mixin_dinamic_charts.volume_with_units')
                : tipo == 'tiempo'
                  ? i18n.t('uti.mixin_dinamic_charts.time_with_units')
                  : i18n.t('uti.mixin_dinamic_charts.foil_with_units'),
            align: 'high',
          },
          labels: {
            overflow: 'justify',
          },
        },
        tooltip: {
          valueSuffix:
            tipo == 'volumen' ? i18n.t('uti.mixin_dinamic_charts.m3') : tipo == 'tiempo' ? i18n.t('uti.mixin_dinamic_charts.hours') : i18n.t('uti.mixin_dinamic_charts.mm'),
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            pointWidth: 15,
          },
        },

        legend: {
          layout: i18n.t('uti.mixin_dinamic_charts.vertical'),
          align: 'right',
          verticalAlign: 'top',
          x: -40,
          y: 10,
          floating: true,
          borderWidth: 1,
          backgroundColor: '#FFFFFF',
          shadow: true,
        },

        series: series_,
      };

      return chartOptions;
    },
  },
};

export default mixinDinamicCharts;
